"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[884],{

/***/ 1884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ heading_Heading; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/base/heading/Heading.tsx

function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Heading = function(_param) {
    var _nodeType = _param.nodeType, nodeType = _nodeType === void 0 ? 'h1' : _nodeType, children = _param.children, props = _objectWithoutProperties(_param, [
        "nodeType",
        "children"
    ]);
    if (children) {
        return(/*#__PURE__*/ react.createElement(nodeType, props, children));
    }
    return null;
};
/* harmony default export */ var heading_Heading = (Heading);

;// CONCATENATED MODULE: ./components/base/heading/index.tsx



/***/ })

}]);